import React from 'react';
import classNames from 'classnames';

const Modal = ({
    text,
    title,
    reading,
    closeText,
    closeFunction,
    modalType,
    image,
    moveToNextQuestion,
    nextQuestionFunc,
    restartQuiz,
    restartQuizFunc,
    restartButtonText,
    landingMessage,
}) => {
    let iconSrc;
    switch (modalType) {
        case 'hint':
            iconSrc = './img/icon-bulb.png';
            break;
        case 'correct':
            iconSrc = './img/icon-correct.png';
            break;
        case 'incorrect':
            iconSrc = './img/icon-incorrect.png';
            break;
        default:
            iconSrc = './img/icon-bulb.png';
    }
    if (image) iconSrc = `img/game_icons/sensors/${image}`;

    const modalClass = classNames(
        'modal',
        {
            'modal-next-question' : moveToNextQuestion,
            'modal-restart-quiz' : restartQuiz,
            'modal-landing-message': landingMessage,
        }
    );

    return (
        <div className={modalClass}>
            <div className="modal-inner">
                <span className="modal-icon-container">
                    <img className="modal-icon" src={iconSrc} alt="" />
                </span>
                {title && <h1 className="modal-title">{title}</h1>}
                <p className={`modal-reading ${reading}`}>{reading}</p>
                <p className="modal-text">{text}</p>
            </div>

            <div className={restartQuiz ? 'restart-quiz' : ''}>
                {restartQuiz && (
                    <div className='App__button'>
                        <div className='App__button-large-container'>
                            <button onClick={() => {
                                closeFunction(false);
                                restartQuizFunc(true);
                            }}>
                                {restartButtonText}
                            </button>
                            <span> </span> {/* Decorative span */}
                            <span> </span> {/* Decorative span */}
                        </div>
                    </div>
               )}

                <div className='App__button'>
                    <div className='App__button-large-container'>
                        <button onClick={() => {
                            closeFunction(false);
                            if (moveToNextQuestion) nextQuestionFunc();
                        }}>
                            {closeText}
                        </button>
                        <span> </span> {/* Decorative span */}
                        <span> </span> {/* Decorative span */}
                    </div>
                </div>
            </div>
        </div>
    )
};

Modal.propTypes = {

};

Modal.defaultProps = {
    image: false,
    moveToNextQuestion: false,
    restartQuiz: false,
    landingMessage: false,
};

export default Modal;
